<template>
  <QCard class="bg-grey-2">
    <QCardSection>
      <h3 class="text-center">
        {{ $t("ETAB.REFERENCE.@INFOS_TITLE") }}
      </h3>
    </QCardSection>
    <QCardSection>
      <fieldset class="q-px-sm">
        <div class="row">
          <div class="col-12 col-md-6 q-pa-sm">
            <!-- candidate reference prospect firstname -->
            <Field
              v-slot="{ errors, field, value }"
              v-model.trim="candidateProspect[ICandidateReferenceProspect.firstname]"
              class="q-my-sm full-width"
              tag="div"
              :name="$filters.formLabelValidation($t('ETAB.REFERENCE.LABELS.@MANAGER_FIRSTNAME_LABEL'))"
              :rules="'required'"
            >
              <QInput
                v-bind="field"
                :model-value="value"
                type="text"
                :label="$t('ETAB.REFERENCE.LABELS.@MANAGER_FIRSTNAME_LABEL')"
                :error="errors.length > 0"
                :error-message="errors[0]"
                class="full-width"
              />
            </Field>
          </div>
          <div class="col-12 col-md-6 q-pa-sm">
            <!-- candidate reference prospect lastname -->
            <Field
              v-slot="{ errors, field, value }"
              v-model.trim="candidateProspect[ICandidateReferenceProspect.lastname]"
              class="q-my-sm"
              tag="div"
              :name="$filters.formLabelValidation($t('ETAB.REFERENCE.LABELS.@MANAGER_LASTNAME_LABEL'))"
              :rules="'required'"
            >
              <QInput
                v-bind="field"
                :model-value="value"
                type="text"
                :label="$t('ETAB.REFERENCE.LABELS.@MANAGER_LASTNAME_LABEL')"
                :error="errors.length > 0"
                :error-message="errors[0]"
              />
            </Field>
          </div>
        </div>

        <!-- candidate reference prospect phoneNumber -->
        <Field
          v-slot="{ errors, field, value }"
          v-model.trim="candidateProspect[ICandidateReferenceProspect.phoneNumber]"
          class="q-pa-sm"
          tag="div"
          :name="$filters.formLabelValidation($t('ETAB.REFERENCE.LABELS.@MANAGER_PHONE_LABEL'))"
          :rules="managerPhoneRules"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            type="text"
            :label="$t('ETAB.REFERENCE.LABELS.@MANAGER_PHONE_LABEL')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>
        <!-- candidate reference prospect email -->
        <Field
          v-slot="{ errors, field, value }"
          v-model.trim="candidateProspect[ICandidateReferenceProspect.email]"
          class="q-pa-sm"
          tag="div"
          :name="$filters.formLabelValidation($t('ETAB.REFERENCE.LABELS.@MANAGER_EMAIL_LABEL'))"
          :rules="managerEmailRules"
        >
          <QInput
            v-bind="field"
            :model-value="value"
            type="email"
            :label="$t('ETAB.REFERENCE.LABELS.@MANAGER_EMAIL_LABEL')"
            :error="errors.length > 0"
            :error-message="errors[0]"
          />
        </Field>
        <p class="q-my-md text-body2">
          {{ $t("ETAB.REFERENCE.@REFERENCE_AUTHORIZE_CONTACT") }}
        </p>
      </fieldset>
    </QCardSection>
  </QCard>
</template>

<script>
  import { ICandidateReferenceProspect, CandidateReferenceProspectModel } from "@core/models";
  import { PHONE_REGEX } from "@core/helpers";
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      candidateProspect: {
        type: Object,
        default: () => new CandidateReferenceProspectModel(),
      },
    },
    computed: {
      managerPhoneRules() {
        const isPhoneNumberRequired = !this.candidateProspect[ICandidateReferenceProspect.email];
        return { required: isPhoneNumberRequired, regex: PHONE_REGEX };
      },
      managerEmailRules() {
        const isEmailRequired = !this.candidateProspect[ICandidateReferenceProspect.phoneNumber];
        return { required: isEmailRequired, email: true };
      },
    },
    created() {
      this.ICandidateReferenceProspect = ICandidateReferenceProspect;
      this.PHONE_REGEX = PHONE_REGEX;
    },
  };
</script>
